import React from 'react';
import Table from './Table';

const SubCategoryList = () => {
  return (
    <div>
      <Table />
    </div>
  )
}

export default SubCategoryList